/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x22de=['requires','TrackChanges'];(function(_0x547e13,_0x22de4b){var _0x5a5dd2=function(_0xf842ef){while(--_0xf842ef){_0x547e13['push'](_0x547e13['shift']());}};_0x5a5dd2(++_0x22de4b);}(_0x22de,0x1c7));var _0x5a5d=function(_0x547e13,_0x22de4b){_0x547e13=_0x547e13-0x0;var _0x5a5dd2=_0x22de[_0x547e13];return _0x5a5dd2;};import{Plugin as _0x25ffb9}from'ckeditor5/src/core';import _0x2952ca from'./realtimecollaborativetrackchanges/cloudservicestrackchangesadapter';import _0x207cd0 from'./realtimecollaborativecomments';export default class p extends _0x25ffb9{static get[_0x5a5d('0x1')](){return[_0x207cd0,_0x2952ca,_0x5a5d('0x0')];}static get['pluginName'](){return'RealTimeCollaborativeTrackChanges';}}